import { render, staticRenderFns } from "./live-gift.vue?vue&type=template&id=405410c2&scoped=true&"
import script from "./live-gift.vue?vue&type=script&lang=js&"
export * from "./live-gift.vue?vue&type=script&lang=js&"
import style0 from "./live-gift.vue?vue&type=style&index=0&id=405410c2&lang=stylus&scoped=true&"
import style1 from "./live-gift.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405410c2",
  null
  
)

export default component.exports